import React, { useState } from 'react';
import { Tabs, Tab, TabPanels, TabPanel, TabList } from '../../../../common/components/Tabs';
import { BlocHTab1 } from './BlocHTab1';
import { BlocHTab2 } from './BlocHTab2';
import { BlocHTab3 } from './BlocHTab3';
import { BlocHTab4 } from './BlocHTab4';

export const BlocHTabs = ({
  match: {
    params: { folderId, tabIndex },
  },
  blocId,
  ...props
}) => {
  const [documentsVersion, setDocumentsVersion] = useState(0);
  const onDocumentsChanged = () => setDocumentsVersion(version => version + 1);

  return (
    <Tabs folderId={folderId} tabIndex={tabIndex} blocId={blocId}>
      <TabList>
        <Tab>Suivi de réalisation</Tab>
        <Tab>Réception docs entreprise</Tab>
        <Tab>Bilan de fin de projet</Tab>
        <Tab>Déblocage de fonds</Tab>
      </TabList>
      <TabPanels>
        <TabPanel>
          <BlocHTab1 {...props} />
        </TabPanel>
        <TabPanel>
          <BlocHTab2 folderId={folderId} onChanged={onDocumentsChanged} />
        </TabPanel>
        <TabPanel>
          <BlocHTab3 {...props} onDocumentsChanged={onDocumentsChanged} />
        </TabPanel>
        <TabPanel>
          <BlocHTab4 {...props} documentsVersion={documentsVersion} />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};
